// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import SlideoutLayout from '../../../layout/slideout/SlideoutLayout';

import { toast } from 'react-toastify';
import CompanyTypeForm from '../components/CompanyTypeForm';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Button from '../../../common/Button';
import { getCompanyTypeById } from '../../../../api/companyTypeApi';
import { useAppDispatch } from '../../../../hooks';
import { saveCompanyType } from '../../../../reducers/companyTypeReducer';

function EditCompanyType({ done, id, cancel }) {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
  } = useForm();

  const [companyType, setCompanyType] = useState({});

  useEffect(() => {
    if (id) {
      getCompanyTypeById(id).then((d) => {
        setCompanyType(d);
      });
    }
  }, [id]);

  const onSubmit = (data) => {
    dispatch(saveCompanyType({ ...companyType, ...data }))
      .unwrap()
      .then(() => {
        toast.success(t('Company type saved'));
        done(companyType);
      });
  };

  return (
    <SlideoutLayout
      title={id ? t('Edit company type') : t('Add company type')}
      cancel={cancel}
      done={done}
      bar={
        <Button
          type="submit"
          text="Save"
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
          testId="save-company-type-button"
        />
      }
    >
      <CompanyTypeForm
        companyType={companyType}
        register={register}
        errors={errors}
        control={control}
      />
    </SlideoutLayout>
  );
}



const mapDispatchToProps = {
  saveCompanyType,
  getCompanyTypeById,
};

export default connect(null, mapDispatchToProps)(EditCompanyType);
